var _path, _path2, _path3, _path4, _path5, _path6;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgBlocks(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M47 41.3V1H1v4h33",
    stroke: "#0073F7",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23 41H0v2h23v-2zM48 41h-5v2h5v-2zM40 6a1 1 0 100-2 1 1 0 000 2zM37 6a1 1 0 100-2 1 1 0 000 2z",
    fill: "#0073F7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1 8v34",
    stroke: "#0073F7",
    strokeWidth: 2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M43 6a1 1 0 100-2 1 1 0 000 2z",
    fill: "#0073F7"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M43 13H31v12h12V13zM39 45h5V31H22v14h6.1M19 37H6v5h13v-5z",
    stroke: "#0073F7",
    strokeWidth: 2
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M7 12H5v2h2v-2zM7 16H5v2h2v-2zM7 20H5v2h2v-2zM27 16h-2v2h2v-2zM27 20h-2v2h2v-2zM11 12H9v2h2v-2zM15 12h-2v2h2v-2zM19 12h-2v2h2v-2zM23 12h-2v2h2v-2zM27 12h-2v2h2v-2zM7 24H5v2h2v-2zM11 24H9v2h2v-2zM15 24h-2v2h2v-2zM19 24h-2v2h2v-2zM23 24h-2v2h2v-2zM27 24h-2v2h2v-2zM31.7 47.4c.3.1.7 0 .9-.3l1.4-1.4 1.4 1.4 1.4-1.4-1.4-1.4L37 43c.4-.4.4-1 0-1.4-.1-.1-.2-.2-.3-.2L29.4 38c-.5-.2-1.1 0-1.3.5-.1.2-.1.5 0 .8l3 7.5c.1.3.3.5.6.6zm2.8-4.8l-2.2 2.1-1.5-3.8 3.7 1.7z",
    fill: "#0073F7"
  })));
}

export default SvgBlocks;